export default {
  resume: '/files/resume.pdf',
  github: 'https://github.com/Serg4554',
  linkedin: 'https://www.linkedin.com/in/serg357'
};
